const HOST_ROUTE_TABLE = {
  HOST: {
    LEGACY: 'DTPortal',
  },
  LEGACY: {
    ROOT: 'DTPortal',
    LOGIN: 'DTPortal/login',
    MAINTENANCE: 'DTPortal/maintenance-system',
    GEOFENCING: 'DTPortal/geofencing',
    REMOTE_UPDATES_PREMIUM: 'DTPortal/remote-updates-premium',
    VEHICLE_HEALTH: 'DTPortal/vehicle-health',
    VEHICLE_HEALTH_CIAM: 'diaglink/v1',
    VTDash: 'VTDash/vehicle-health',
  },
  ESERVICES: {
    E_ROOT: 'DTPortal/eservices',
  },
  XOTA: {
    ROOT: 'DTPortal/xota',
  },
  FUEL_ANALYTICS: {
    ROOT: 'DTPortal/fuel-analytics',
  },
};

export default HOST_ROUTE_TABLE;
